<div class="container-fluid tp-box" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="card">
			<div class="card-header card-header-rose card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false, '')">
					<i class="material-icons">payment</i>
				</div>
				<h3 class="card-title">Payments {{ title }}</h3>
			</div>
			<div class="card-body" *ngIf="viewing">
				<div class="text-right mb-2">
					<button class="btn btn-sm btn-success" (click)="exportXls()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-excel-o"></i> XLS
					</button>
					<button class="btn btn-sm btn-danger ml-2" (click)="exportPdf()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-pdf-o"></i> PDF
					</button>
				</div>
				<div class="table" #print_table>
					<table class="table">
						<tr>
							<th>Vendor</th>
							<th>Balance</th>
						</tr>
						<tr *ngFor="let v of viewing">
							<td>{{ v.supplierid }}</td>
							<td>{{ v.balance | currency }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-rose card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(payments, 'All')">
					<i class="material-icons">payment</i>
				</div>
				<p class="card-category">Payments</p>
				<h3 class="card-title">
					<span *ngIf="payments">
						{{ payments.length }}
					</span>
					<span *ngIf="!payments">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
				</h3>
			</div>
			<div class="card-footer">
				<div class="stats pointer">
					<a (click)="toggleFlip(payments, 'All')">
						<i class="material-icons">content_copy</i>
						View Now</a>
				</div>
			</div>
		</div>
	</div>
</div>
